import React, { useState } from 'react';

function fmt(n) {
  if (!n && n !== 0) return '—';
  if (n >= 10000000) return `₹${(n/10000000).toFixed(2)} Cr`;
  if (n >= 100000)   return `₹${(n/100000).toFixed(2)} L`;
  return `₹${Number(n).toLocaleString('en-IN')}`;
}

export default function HoldingsTable({ holdings, totalMarket, totalCollateral, preview, isMobile }) {
  const [search, setSearch] = useState('');

  const filtered = (holdings || []).filter(h =>
    !search || h.scrip_code?.toLowerCase().includes(search.toLowerCase()) ||
    h.scrip_name?.toLowerCase().includes(search.toLowerCase())
  );

  const display = preview ? filtered.slice(0, 5) : filtered;

  // Mobile layout — card style per scrip
  if (isMobile) {
    return (
      <div>
        {/* Search */}
        <div style={{ padding:'8px 12px', borderBottom:'1px solid #f0e8e5' }}>
          <div style={{ display:'flex', alignItems:'center', gap:6, border:'1px solid #e0d8d5', borderRadius:6, padding:'6px 10px', background:'#fdfcfc' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search scrip..."
              style={{ border:'none', outline:'none', fontSize:12, color:'#333', flex:1, background:'transparent' }} />
          </div>
        </div>

        {/* Cards */}
        <div style={{ padding:'8px 12px' }}>
          {display.map((h, i) => (
            <div key={i} style={{ padding:'10px 0', borderBottom:'1px solid #f8f4f2' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:'#6B1C2A' }}>{h.scrip_code}</div>
                  <div style={{ fontSize:11, color:'#888' }}>{h.scrip_name || '—'}</div>
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontSize:13, fontWeight:600, color:'#333' }}>{fmt(h.market_value)}</div>
                  <div style={{ fontSize:10, color:'#888' }}>Market Value</div>
                </div>
              </div>
              <div style={{ display:'flex', gap:12, fontSize:11, color:'#888' }}>
                <span>Qty: <strong style={{ color:'#333' }}>{Number(h.net_quantity||0).toLocaleString('en-IN')}</strong></span>
                <span>Price: <strong style={{ color:'#333' }}>₹{h.price ? Number(h.price).toFixed(2) : '—'}</strong></span>
                <span>Collateral: <strong style={{ color:'#6B1C2A' }}>{fmt(h.gross_collateral_value)}</strong></span>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ textAlign:'center', color:'#aaa', fontSize:12, padding:20 }}>No scrips found</div>
          )}
        </div>

        {/* Totals */}
        {!preview && (
          <div style={{ padding:'10px 12px', background:'#fdfcfc', borderTop:'2px solid #e8e0dd', display:'flex', justifyContent:'space-between' }}>
            <div style={{ fontSize:11 }}>
              <div style={{ color:'#888', marginBottom:2 }}>Total Market</div>
              <div style={{ fontWeight:700, color:'#333' }}>{fmt(totalMarket)}</div>
            </div>
            <div style={{ fontSize:11, textAlign:'right' }}>
              <div style={{ color:'#888', marginBottom:2 }}>Total Collateral</div>
              <div style={{ fontWeight:700, color:'#6B1C2A' }}>{fmt(totalCollateral)}</div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Desktop table layout
  return (
    <div style={{ background:'#fff', border:'1px solid #f0e8e5', borderRadius:10, overflow:'hidden', marginBottom:16 }}>
      <div style={{ padding:'10px 14px', borderBottom:'1px solid #f0e8e5', display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ fontSize:12, fontWeight:600, color:'#333' }}>Holdings</div>
        <div style={{ flex:1 }}>
          <div style={{ display:'flex', alignItems:'center', gap:6, border:'1px solid #e0d8d5', borderRadius:6, padding:'4px 10px', background:'#fdfcfc', maxWidth:200 }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search Stock Pledge"
              style={{ border:'none', outline:'none', fontSize:11, color:'#333', flex:1, background:'transparent' }} />
          </div>
        </div>
        <div style={{ fontSize:11, color:'#888' }}>{filtered.length} scrips</div>
      </div>
      <div style={{ overflowX:'auto' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:11 }}>
          <thead>
            <tr style={{ background:'#fdfcfc' }}>
              {['Scrip','Name','Qty','Price','Market Value','Haircut %','Collateral'].map(h => (
                <th key={h} style={{ padding:'8px 10px', textAlign: h==='Qty'||h==='Price'||h==='Market Value'||h==='Haircut %'||h==='Collateral' ? 'right' : 'left', fontWeight:600, color:'#888', fontSize:10, textTransform:'uppercase', letterSpacing:'0.04em', borderBottom:'1px solid #f0e8e5', whiteSpace:'nowrap' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {display.map((h, i) => (
              <tr key={i} style={{ borderBottom:'1px solid #f8f4f2' }}
                onMouseEnter={e => e.currentTarget.style.background='#fdf9f8'}
                onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                <td style={{ padding:'7px 10px', fontWeight:700, color:'#6B1C2A' }}>{h.scrip_code}</td>
                <td style={{ padding:'7px 10px', color:'#555', maxWidth:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{h.scrip_name || '—'}</td>
                <td style={{ padding:'7px 10px', textAlign:'right' }}>{Number(h.net_quantity||0).toLocaleString('en-IN')}</td>
                <td style={{ padding:'7px 10px', textAlign:'right' }}>{h.price ? Number(h.price).toFixed(2) : '—'}</td>
                <td style={{ padding:'7px 10px', textAlign:'right' }}>{fmt(h.market_value)}</td>
                <td style={{ padding:'7px 10px', textAlign:'right', color:'#888' }}>{h.haircut != null ? `${h.haircut}%` : '—'}</td>
                <td style={{ padding:'7px 10px', textAlign:'right', fontWeight:600, color:'#6B1C2A' }}>{fmt(h.gross_collateral_value)}</td>
              </tr>
            ))}
          </tbody>
          {!preview && totalMarket && (
            <tfoot>
              <tr style={{ background:'#fdfcfc', borderTop:'2px solid #e8e0dd' }}>
                <td colSpan={4} style={{ padding:'8px 10px', fontWeight:600, fontSize:11 }}>Total</td>
                <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:700 }}>{fmt(totalMarket)}</td>
                <td></td>
                <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:700, color:'#6B1C2A' }}>{fmt(totalCollateral)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
